import { vindDraaitafel } from '../../vergelijk/draaitafels'
import type { Draaicamera } from '../../vergelijk/draaitafels'

/**
 * De Matics als studiobeeld van Linde in de hal (21 oktober): welk beeld,
 * welke camera, en waar de uitsnede in het beeld van Linde ligt.
 *
 * Geen nieuwe bestanden: de beelden zijn de draaitafels die de productviewer
 * al heeft (`public/products/product-0X/draai/NN.webp`, uit de 1920-bron van
 * linde-mh.com bijgesneden en verkleind). De camera is die van
 * `DRAAITAFELS`, teruggerekend op het 960-beeld; `crop` is waar de webp in dat
 * 960-beeld ligt. Gemeten door per frame het alfakader van de webp op dat van
 * het 960-frame (`referenties-draai/`) te leggen, kleinste kwadraten over alle
 * frames en randen: de grootste afwijking is 1,2 px (K), 3,8 (R), 0,7 (L) en
 * 0,8 (C), de silhouetoverlap 0,985–0,998.
 *
 * De T-MATIC heeft sinds 22 oktober ook een draaitafel: die van de T-MATIC
 * core op linde-mh.com (/T-MATIC-core/, niet de oude /T-MATIC/). Zijn beelden
 * zijn de originelen van 1200 px, bijgesneden op het alfakader van alle 36
 * samen; de uitsnede is daarom exact, in pixels van dat origineel
 * (`bron: 1200`), en niet gemeten zoals bij de andere vier.
 */
export interface LindeBron {
  /** Map met de beelden, met afsluitende slash. */
  map: string
  /** Welke frames er zijn, en bij welk frame-nummer van de draaitafel. */
  frames: number[]
  camera: Draaicamera
  /** Uitsnede: x0, y0, x1, y1 in pixels van een beeld van `bron` breed. */
  crop: [number, number, number, number]
  bron: number
  /** Helderheid van het studiobeeld in de hal: het licht van Linde is witter dan dat van de hal. */
  licht: number
}

const tafel = (model: 'K-Matic' | 'R-Matic' | 'L-Matic' | 'C-Matic' | 'T-Matic') => {
  const t = vindDraaitafel(model)
  if (!t) throw new Error(`geen draaitafel voor ${model}`)
  return t
}

export const LINDE_BEELD: Record<'K-Matic' | 'R-Matic' | 'L-Matic' | 'C-Matic' | 'T-Matic', LindeBron> = {
  'K-Matic': { map: '/products/product-02/draai/', frames: tafel('K-Matic').frames, camera: tafel('K-Matic').camera, crop: [131.69, 1.03, 826.54, 959.44], bron: 960, licht: 0.85 },
  'R-Matic': { map: '/products/product-03/draai/', frames: tafel('R-Matic').frames, camera: tafel('R-Matic').camera, crop: [40.27, -0.6, 917.89, 957.08], bron: 960, licht: 0.85 },
  'L-Matic': { map: '/products/product-04/draai/', frames: tafel('L-Matic').frames, camera: tafel('L-Matic').camera, crop: [183.65, 157.14, 772.91, 787.42], bron: 960, licht: 1 },
  'C-Matic': { map: '/products/product-05/draai/', frames: tafel('C-Matic').frames, camera: tafel('C-Matic').camera, crop: [74.72, 308.29, 883.3, 756.17], bron: 960, licht: 1 },
  'T-Matic': { map: '/products/product-01/draai/', frames: tafel('T-Matic').frames, camera: tafel('T-Matic').camera, crop: [148, 43, 1061, 1164], bron: 1200, licht: 0.9 },
}
